/* eslint-disable max-len */
import { chakra, useToast, type UseToastOptions } from '@chakra-ui/react';
import React, { ElementType } from 'react';

import { ToastView } from './toast-view';

type Options =
    Omit<UseToastOptions
    & {
    // Omitting these props as it is not part of the current design
}, 'isClosable' | 'icon' | 'title'>;

export function useMathleticsToast (options?: UseToastOptions) {
    const toast = useToast({
        position: 'top',
        containerStyle: {
            width: '100%',
            paddingLeft: '24px',
            paddingRight: '24px',
            marginTop: '16px'
        },
        ...options,
        isClosable: true
    });

    return (innerOptions?: Options) => toast({
        ...innerOptions,
        render: ({ onClose }) => {
            let Icon: null | ElementType = null;
            let borderColor: string | undefined = undefined;

            if (innerOptions?.status === 'error') {
                Icon = ErrorIcon;
                borderColor = 'error.700';
            }

            return (
                <ToastView
                    borderColor={borderColor}
                    onClose={onClose}
                    Icon={Icon}
                >
                    <span
                        dangerouslySetInnerHTML={{
                            // @ts-ignore allow this
                            __html: innerOptions.description
                        }}
                    />
                </ToastView>
            );
        }
    });
}

export function ErrorIcon () {
    return (
        <chakra.svg minWidth={'24px'} width="24px" height="24px" viewBox="0 0 24 24" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.6004 11.9999C21.6004 17.3018 17.3023 21.5999 12.0004 21.5999C6.69846 21.5999 2.40039 17.3018 2.40039 11.9999C2.40039 6.69797 6.69846 2.3999 12.0004 2.3999C17.3023 2.3999 21.6004 6.69797 21.6004 11.9999ZM13.2004 16.7999C13.2004 17.4626 12.6631 17.9999 12.0004 17.9999C11.3376 17.9999 10.8004 17.4626 10.8004 16.7999C10.8004 16.1372 11.3376 15.5999 12.0004 15.5999C12.6631 15.5999 13.2004 16.1372 13.2004 16.7999ZM12.0004 5.9999C11.3376 5.9999 10.8004 6.53716 10.8004 7.1999V11.9999C10.8004 12.6626 11.3376 13.1999 12.0004 13.1999C12.6631 13.1999 13.2004 12.6626 13.2004 11.9999V7.1999C13.2004 6.53716 12.6631 5.9999 12.0004 5.9999Z"
                fill="#C51B29"
            />
        </chakra.svg>
    );
}
